// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import { activateTooltips } from "./utils/tooltips"

// Make Bootstrap available globally for data-bs-* attributes to work
window.bootstrap = bootstrap

// Initialize Bootstrap components after Turbo navigations
document.addEventListener("turbo:load", () => {
  // Re-initialize dropdowns after Turbo navigation
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
    new bootstrap.Dropdown(el)
  })

  activateTooltips()
})

document.addEventListener("turbo:frame-load", (event) => {
  activateTooltips(event.target)
})
